import { GetBlogListParameters } from "@iewcasia/Services/BlogListService";
import parseQueryString from "@insite/client-framework/Common/Utilities/parseQueryString";
import { createHandlerChainRunner, Handler } from "@insite/client-framework/HandlerCreator";
import { HasPagingParameters } from "@insite/client-framework/Services/ApiService";
import convertToNumberIfString from "@insite/mobius/utilities/convertToNumberIfString";
import cloneDeep from "lodash/cloneDeep";
import merge from "lodash/merge";
import qs from "qs";

interface Parameter {
    pageSize?: number;
    page?: number;
    pageId?: string;
    search?: string;
    isLandingPage?: boolean;
    parameters: HasPagingParameters;
}

interface Props {
    getBlogListParameters?: GetBlogListParameters;
    filterQuery?: string;
}

type HandlerType = Handler<Parameter, Props>;

export const SetFilterQuery: HandlerType = props => {
    const queryObject = cloneDeep(props.parameter.parameters);
    if (!queryObject.page) {
        delete queryObject.page;
    }

    props.filterQuery = qs.stringify(queryObject, { arrayFormat: "comma", skipNulls: true });
};

export const DispatchSetFilterQuery: HandlerType = props => {
    props.dispatch({
        type: "Custom/BlogListState/SetFilterQuery",
        result: props.filterQuery,
    } as any);
};

export const MergePaginationParameters: HandlerType = props => {
    const stateFilters = cloneDeep(props.parameter.parameters);
    let newFilters = stateFilters;

    if (!props.parameter.isLandingPage) {
        const { pageSize, page } = parseQueryString<{ pageSize?: string; page?: string }>(props.parameter.search || "");
        if (pageSize) {
            newFilters = merge(newFilters, { pageSize: convertToNumberIfString(pageSize) });
        }

        if (page) {
            newFilters = merge(newFilters, { page: convertToNumberIfString(page) });
        }

        props.getBlogListParameters = { ...newFilters, pageId: props.parameter.pageId };
    }

    props.dispatch({
        type: "Custom/BlogListState/Filter",
        parameters: newFilters,
    } as any);
};

export const chain = [SetFilterQuery, DispatchSetFilterQuery, MergePaginationParameters];

const setFilterQuery = createHandlerChainRunner(chain, "SetFilterQuery");
export default setFilterQuery;
